// shared/useBaseContext.js
import { useReducer, useCallback } from 'react';

// Common reducer actions
export const baseActions = {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR', 
  CLEAR_ERROR: 'CLEAR_ERROR',
  SET_DATA: 'SET_DATA',
  UPDATE_ITEM: 'UPDATE_ITEM',
  ADD_ITEM: 'ADD_ITEM',
  REMOVE_ITEM: 'REMOVE_ITEM'
};

// Base reducer that handles common actions
export const createBaseReducer = (customReducer) => (state, action) => {
  // Handle common actions first
  switch (action.type) {
    case baseActions.SET_LOADING:
      return { ...state, loading: action.payload };
    case baseActions.SET_ERROR:
      return { ...state, error: action.payload, loading: false };
    case baseActions.CLEAR_ERROR:
      return { ...state, error: null };
    default:
      // Delegate to custom reducer
      return customReducer ? customReducer(state, action) : state;
  }
};

// Base initial state
export const createBaseState = (customState = {}) => ({
  loading: true,
  error: null,
  ...customState
});

// Hook for common context functionality
export const useBaseContext = (initialState, customReducer) => {
  const baseReducer = createBaseReducer(customReducer);
  const [state, dispatch] = useReducer(baseReducer, initialState);

  const setLoading = useCallback((loading) => {
    dispatch({ type: baseActions.SET_LOADING, payload: loading });
  }, []);

  const setError = useCallback((error) => {
    dispatch({ type: baseActions.SET_ERROR, payload: error });
  }, []);

  const clearError = useCallback(() => {
    dispatch({ type: baseActions.CLEAR_ERROR });
  }, []);

  return {
    state,
    dispatch,
    setLoading,
    setError,
    clearError
  };
};
